import React, { Dispatch, SetStateAction, useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getItineraryById, manageItineraryEnquiry } from "../../../../api/itinerary.api";
import { SelectedUserContext } from "../../../../context/selecteduser.context";
import { CalendarIconSvg, MoonIconSvg } from "../../../../assets/svg";
import { splitDate } from "../../../../utils/splitDate";
import ModalWrapper from "../../../../components/ModalWrapper/ModalWrapper";
import ItineraryDetailsModal from "../../../../components/Modals/ItineraryInfoModal/ItineraryInfoModal";
import dayjs from "dayjs";
import './ItineraryDetailsCard.scss'

interface IItineraryDetailsCard{
  item: any;
  itineraryType: string;
  itineraryIdsArr: string[];
  setItineraryIdsArr: Dispatch<SetStateAction<string[]>>;
  setUpcomingSelectedItinerary: Dispatch<SetStateAction<string>>;
  handleEnquiryTrigger: (item: any) => void;
}

const ItineraryDetailsCard: React.FC<IItineraryDetailsCard> = (props) => {
  const { item, itineraryType, itineraryIdsArr, setItineraryIdsArr, handleEnquiryTrigger, setUpcomingSelectedItinerary } = props;
  const { existingEnquiry } = useContext(SelectedUserContext);
  const [modalViewState, setModalViewState] = useState<boolean>(false);
  const [itineraryData, setItineraryData] = useState<any>(null);

  const toggleDetailsModal = () => {
    setModalViewState(prev => !prev)
  }

  const handleInfoClick = async (id: string) => { 
    const data = await getItineraryById(id);
    if (data?.status === 200) {
      setItineraryData(data?.result);
      toggleDetailsModal();
    }
  }

  const handleSelectedCards = async (e: any, id: string) => {
    if (itineraryType === 'upcoming' && e.target.checked) {
      setUpcomingSelectedItinerary(item?.id)
      handleEnquiryTrigger(item);
      return;
    }
    if (e.target.checked) {
      setItineraryIdsArr([...itineraryIdsArr, id]);
      manageItineraryEnquiry(existingEnquiry?.id, { itineraryIds: [...itineraryIdsArr, id] });
    } else {
      const tempArr = itineraryIdsArr.filter((itineraryId: string) => itineraryId !== id)
      setItineraryIdsArr([...tempArr]);
      manageItineraryEnquiry(existingEnquiry?.id, { itineraryIds: [...tempArr] });
    }
  }

  function convertSnakeCaseToRegularString(inputString:string) {
    // Split the string by underscores
    const words = inputString?.split('_');

    // Capitalize each word and join them with a space
    const regularString = words?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');

    return regularString;
  }

  return (
    <div className="min-h-[86px] h-[86px]  mx-1 my-3 border rounded bg-light itinerary-details-card-wrapper">
      <div className="d-flex justify-content-between align-items-center h-100 ps-3">
        <div className="w-[40px]">
          <input type="checkbox" checked={itineraryIdsArr?.includes(item?.id)} id={item?.id} onChange={(e) => handleSelectedCards(e, item?.id)} />
          <label htmlFor={item?.id} className="flex items-center">
          </label>
        </div>
        <div className="d-flex flex-col w-100 min-h-100 h-100">
          <Row className="border-bottom  align-content-center h-100 m-0">
            <Col className="h-100 d-flex align-items-center route-name">
              <p className="m-0 font-bold text-[18px] text-[#3a3a3a]">{item?.route}</p>
            </Col>
            <Col className="d-flex justify-content-end align-items-center h-100 px-0">
              <p className="px-2 m-0 bg-[#C8F5FF] flex align-items-center h-100">Summer Vacation</p>
              <p className="px-2 m-0 bg-[#F6C1FF] flex align-items-center h-100">Best Seller</p>
            </Col>
          </Row>
          <Row className="h-100">
            <Col xs={4} className="d-flex align-items-center">
              <CalendarIconSvg width={17.5} height={20} fill="#7a7a7a"/>
              <p className="mx-1 my-auto">
                {" "}
                {dayjs(splitDate(item?.start_time)).format("DD MMM YYYY")} - {dayjs(splitDate(item?.end_time)).format("DD MMM YYYY")}
              </p>
            </Col>
            <Col className="d-flex align-items-center">
              <p className="mx-1 my-auto text-[#C35379]">{convertSnakeCaseToRegularString(item?.trip_type)}</p>
            </Col>
            <Col className="d-flex align-items-center">
              <MoonIconSvg fill="#7a7a7a"/>
              <p className="mx-1 my-auto">{item?.night_count} Nights</p>
            </Col>
            <Col className="d-flex align-items-center">
              <p className="mx-1 my-auto text-capitalize">{item?.ship_name?.toLowerCase()}</p>
            </Col>
            <Col className="d-flex align-items-center justify-content-end mx-2">
              <p className="mx-1 my-auto font-weight-bold text-[#92278F] cursor-pointer" onClick={() => handleInfoClick(item?.id)}>
                More Info &gt;
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <ModalWrapper show={modalViewState} handleClose={toggleDetailsModal}>
        <ItineraryDetailsModal itineraryDetails={itineraryData}/>
      </ModalWrapper>
    </div>
  );
};
export default ItineraryDetailsCard;
